'use strict';

module.exports = /*@ngInject*/ ["$timeout", function selectTab($timeout) {
    return {
        scope: {
            currenttab: "="
        },
        restrict: 'A',
        link: function (scope, element, attrs) {
            // watch the scope.currentab variable
            // when the new value equals the id of the tab this directive is on > trigger the click
            scope.$watch('currenttab', function (newvalue, oldvalue) {
                if (newvalue == attrs.id) {
                    $timeout(function () {
                        angular.element('#' + attrs.id).trigger('click');
                    });
                }
            });
        }
    };
}];
